import { useNavigate } from "react-router-dom";
import SalaListItem from "./SalaListItem";

const getNameRoom = (sala) => {
  if (sala.isGroup) {
    return `Grupo: ${sala.descricao}`;
  }
  return sala.listaSP.map((sp) => `${sp.usuario.nome} (${sp.usuario.perfil})`).join(" - ");
};

const MensagemAll = ({ sala }) => {
  const navigate = useNavigate();
  const nameRoom = getNameRoom(sala);

  const handleSalaMensagem = () => {
    navigate("/sala-mensagem", {
      state: { sala, nameRoom },
    });
  };

  return (
    <SalaListItem
      sala={sala}
      usuarios={sala.isGroup ? [] : sala.listaSP.map((sp) => sp.usuario)}
      title={nameRoom}
      onOpen={handleSalaMensagem}
    />
  );
};

export default MensagemAll;
